import {AppNavigationActions} from "../actions/AppNavigationActions";
import {closeOnBack} from "../../utils/NativeBridge";
import {Colors} from "../../utils/Colors";

export const AppNavigationReducer = (state, action) => {

    switch (action.type) {
        case AppNavigationActions.SETUP_HELP:
            return {...state, helpEnabled: action.value.enabled, helpOptions: {...state.helpOptions, ...action.value.options}};

        case AppNavigationActions.OPEN_HELP:
            return {...state, helpOptions: {...state.helpOptions, open: true}};

        case AppNavigationActions.CLOSE_HELP:
            return {...state, helpOptions: {...state.helpOptions, open: false}};

        case AppNavigationActions.ERROR_COL:
            return {...state, navColor: Colors.NAV_ERROR_COL};

        case AppNavigationActions.RESET_COL:
            return {...state, navColor: Colors.NAV_COL};

        case AppNavigationActions.CLOSE_ON_BACK:
            return {...state, onBackClicked: closeOnBack};

        case AppNavigationActions.ON_BACK_DEFAULT:
            return {...state, onBackClicked: null};

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/appNavigation/reducers/AppNavigationReducer.js